import { actionGenerator } from '../../redux/actionGenerator';
import { EFormLayoutModalActionType } from './types';
import { EEventType } from '../../types/eventEmitter';
var openModal = actionGenerator(EFormLayoutModalActionType.Opened);
export function openFormLayoutModal() {
  return function (dispatch, getState, context) {
    var emitter = context.emitter;
    dispatch(openModal());
    emitter.emit(EEventType.FormLayoutModalOpened);
  };
}